import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Typography, Grid, IconButton, Hidden, Box, Button } from '@mui/material'
import { Close } from '@mui/icons-material'
import { makeStyles } from '@mui/styles'

export const useStyles = makeStyles(({ palette, spacing, typography }) => ({
  header: {
    ...typography.heading.h5,
    fontWeight: typography.weight.medium
  }
}))

const Header = ({ title, onClose, groupCategorySelected = {} }) => {
  const classes = useStyles()
  const navigate = useNavigate()

  const handleNavigateToGroupCategory = () => {
    navigate(`/${groupCategorySelected.sk}/${groupCategorySelected.staticUrl}`)
    onClose?.() // Close the explore menu after navigation
  }

  return (
    <Grid container justifyContent='space-between' alignItems='center' wrap='nowrap'>
      <Grid item>
        <Box ml={1}>
          <Typography variant='h5' className={classes.header}>
            {title}
          </Typography>
          {groupCategorySelected?.sk && groupCategorySelected?.staticUrl && (
            <Button
              onClick={handleNavigateToGroupCategory}
              style={{
                marginLeft: '6px',
                textTransform: 'none',
                margin: 0,
                padding: 0,
                minWidth: 'auto',
                background: 'none',
                border: 'none',
                boxShadow: 'none',
                color: '#1976d2',
                textDecoration: 'underline',
                '&:hover': {
                  background: 'none',
                  textDecoration: 'underline'
                }
              }}
            >
              <Typography variant='subtitle2' style={{ color: 'inherit', textDecoration: 'inherit' }}>See all</Typography>
            </Button>
          )}
        </Box>
      </Grid>
      <Hidden smDown>
        <Grid item>
          <IconButton
            aria-label='close navigation menu'
            onClick={onClose}
            data-test='nav-close-modal'
            size='large'
          >
            <Close />
          </IconButton>
        </Grid>
      </Hidden>
    </Grid>
  )
}

export default Header
